const initialState = {
  name: null,
};

export default initialState;
